export default __webpack_public_path__ + "static/media/product-item-02.d258f64d.jpg";